export var NavigationDropdownMode;
(function (NavigationDropdownMode) {
    NavigationDropdownMode[NavigationDropdownMode["None"] = 0] = "None";
    NavigationDropdownMode[NavigationDropdownMode["TwoLevels"] = 1] = "TwoLevels";
    NavigationDropdownMode[NavigationDropdownMode["ThreeLevels"] = 2] = "ThreeLevels";
    NavigationDropdownMode[NavigationDropdownMode["ThreeLevelsPromo"] = 3] = "ThreeLevelsPromo";
    NavigationDropdownMode[NavigationDropdownMode["YourSolution"] = 4] = "YourSolution";
})(NavigationDropdownMode || (NavigationDropdownMode = {}));
